import { userModule } from '@/store/modules/ModuleUser';
/** 权限指令
 * binding的value中可选的参数：权限编码数组或者单个编码 e.g. [xxxx,yyyy] , xxx
 */
export default {
	/** 更新时 */
	update(e: any, binding: any) {
		updateElement(e, binding);
	},
	/** 插入时 */
	inserted(e: any, binding: any) {
		updateElement(e, binding);
	}
};

/** 更新元素 */
function updateElement(e: any, binding: any): void {
	// 获取绑定的参数
	const { value }: any = binding;
	const showActionCode = [];
	const userPermissions = userModule.userData?.permissions ?? [];
	if (typeof value === 'string') {
		showActionCode.push(value);
	} else {
		showActionCode.push(...value);
	}

	// console.log('showActionCode: ', showActionCode);

	const show = showActionCode.reduce((prev: any, cur: any) => userPermissions.findIndex((x: any) => x.permission === cur) > -1 || prev, false);
	if (!show) {
		(e as HTMLElement).remove();
	}
}
